import { ComponentType, ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import { usePriceMode } from '../../hooks/usePriceMode';
import { PRICE_MODE_CONFIG, PriceMode } from '../../priceMode';

export type PriceModeGuardProps = {
  mode: PriceMode;
  children: ReactNode;
};

// As duas rotas continuam existindo (RN04), mas cada uma só exibe a tela do modo configurado para o cliente.
// Cobre os acessos que não passam pelo menu: "Sair do Administrador", F5, URL digitada e voltar do navegador.
export const PriceModeGuard = ({ mode, children }: PriceModeGuardProps) => {
  const { data: clientMode, isLoading, isError } = usePriceMode();

  if (isLoading) return null;
  if (isError || !clientMode || clientMode === mode) return <>{children}</>;

  return <Redirect to={PRICE_MODE_CONFIG[clientMode].route} />;
};

export function withPriceModeGuard<P extends object>(Component: ComponentType<P>, mode: PriceMode): ComponentType<P> {
  const GuardedComponent = (props: P) => (
    <PriceModeGuard mode={mode}>
      <Component {...props} />
    </PriceModeGuard>
  );
  GuardedComponent.displayName = `withPriceModeGuard(${Component.displayName || Component.name || 'Component'})`;
  return GuardedComponent;
}
